import { render, staticRenderFns } from "./difference-modal.vue?vue&type=template&id=6656e62f&scoped=true"
import script from "./difference-modal.vue?vue&type=script&lang=js"
export * from "./difference-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6656e62f",
  null
  
)

export default component.exports